import list from '../../images/onboarding/list.svg';
import dogBox from '../../images/pup-sparkles-box.svg';
import foodBowl from '../../images/onboarding/food-bowl.svg';

export const SLIDES = [
  {
    img: list.src,
    imgAlt: 'todo list',
    heading: '1. Meet & Greet',
    text:
      'Our quiz lets us get to know you and your dog through a few essential questions.',
  },
  {
    img: foodBowl.src,
    imgAlt: 'carrot and chicken leg over a food bowl',
    heading: '2. Get Personal',
    text: 'Make your selections based on our recommended meal plans.',
  },
  {
    img: dogBox.src,
    imgAlt: 'dog excited about open Ollie box',
    heading: '3. Mealtime Delivered',
    text: 'Freshly prepared food arrives at your door, ready to be devoured.',
  },
];
